import React, { useState, useEffect } from 'react'
import {
    ListBox
} from '@progress/kendo-react-listbox';
// * Helpers
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';
import { useTranslation } from 'react-i18next';
import API from "../../services/api";


/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowRight, ImArrowLeft } from 'react-icons/im'

// Used to show the selected item inside the box
const SELECTED_FIELD = "selected";

const Step6 = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');
    // * Selected benefit id state
    const [selectedBenefitId, setSelectedBenefitId] = useState(0);
    // * Input state
    const [policyGaps, setPolicyGaps] = useState('');
    const [impIssues, setImpIssues] = useState('');
    const [policyRecom, setPolicyRecom] = useState('');
    const [annotations, setAnnotations] = useState('');
    // * ListBox components state
    const [state, setState] = React.useState({
        benefitsList: []
    });

    // * we use useEffect to call the function that returns the step2 data
    useEffect(() => {
        if (props.activeStep === 6) {
            // Setting the states as shown below helps to avoid displaying incorrect data when passing 
            // from one step to the next (or previous).
            setPolicyGaps('');
            setImpIssues('');
            setPolicyRecom('');
            setAnnotations('');
            setSelectedBenefitId(0);
            // Gets benefits list
            getStep6_Benefits();
        }
    }, [props.activeStep]);// eslint-disable-line react-hooks/exhaustive-deps

    // *
    const getStep6_Benefits = async () => {
        try {
            // Gets the data from each of the lists, they are all fetched at once 
            // to avoid losing data for different setSate in different functions.
            const responseBenefits = await API.get(`/model/step4BenefitsList?modelId=${props.modelData.modelid}`);
            // if error in request
            if (responseBenefits.data.code !== 100) {
                Notifications.notify(responseBenefits.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                const benefitsListBD = responseBenefits.data.data;

                // Set the state and select the option
                const benefitsListFirstSelected = benefitsListBD.map((item, i)=>{
                    if (i === 0) {
                        item[SELECTED_FIELD] = true;
                    } else {
                        item[SELECTED_FIELD] = false;
                    }
                    return item;
                });
                setState({
                    ...state,
                    benefitsList: benefitsListFirstSelected
                });

                // saves the benefit id as state
                setSelectedBenefitId(benefitsListBD[0].benefitId);
                // Fills the inputs with the selected benefit information
                fillInputs(benefitsListBD[0].benefitId);

            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    // * This function is called when the PREVIOUS arrow is clicked.
    // * Saves the data of the step 4
    // * If the saves was ok, the step 3 is called
    const onPreviousClick = async () => {
        // Only saves when is in edit mode
        if (props.isEditMode) {
            // * When calling an async/await function that returns a boolean, you must wait for its response, 
            // * since it is a promise and will NOT return the desired bool.
            const returnValue = await saveStep6Data();
            if (returnValue) {
                props.changeStep(5);
            }
        } else {
            props.changeStep(5);
        }
    }

    // * This function is called when the NEXT arrow is clicked.
    // * Saves the data of the step 4
    // * If the saves was ok, the step 5 is called
    const onNextClick = async () => {
        // Only saves when is in edit mode
        if (props.isEditMode) {
            // * When calling an async/await function that returns a boolean, you must wait for its response, 
            // * since it is a promise and will NOT return the desired bool.
            const returnValue = await saveStep6Data();
            if (returnValue) {
                props.changeStep(7);
            }
        } else {
            props.changeStep(7);
        }
    }

    // * Calls the API to save the data of the selected benefit
    // * If it returns false, it means that some input is wrong.
    // * If it returns true, it means that everything is OK.
    const saveStep6Data = async () => {
        // * Validations
        // --- selected benefit validation
        // selectedBenefitId = 0 means that no benefit was selected, so when going to step 7 or 5 nothing is saved.
        if (selectedBenefitId === 0) {
            return true;
        }
        // --- empty validations
        // if (validator.isEmpty(policyGaps.toString()) || validator.isEmpty(impIssues.toString()) ||
        //     validator.isEmpty(policyRecom.toString()) || validator.isEmpty(annotations.toString())) {
        //     Notifications.notify(t('model.values_required'), ERROR_NOTIFICATION);
        //     return false;
        // }

        // data to be sent
        let data = {
            modelid: props.modelData.modelid,
            benefitId: selectedBenefitId,
            policyGaps: policyGaps,
            implemIssues: impIssues,
            policyRecom: policyRecom,
            suppleAnnotations: annotations

        }

        // * call the api to do the upsert
        const res = await API.post('/model/step6InsertData', data);

        // * if errors exist, it is displayed as a notification
        if (res.data.code !== 100) {
            Notifications.notify(t(`model.${res.data.code}`), ERROR_NOTIFICATION);
            return false;
        }

        return true;
    }

    // Triggered when an user clicks an element inside the box of Benefits
    const modelBenfitsClick = async (event, data) => {
        let canSave = true;
        // Saves the previous benefit data (like an onChange event)
        if (selectedBenefitId !== 0) {
            // selectedBenefit == 0 means that there is no previous benefit
            // Only saves when is in edit mode
            if (props.isEditMode) {
                // Tries to save the previous benefit
                const returnValue = await saveStep6Data();
                // If was successfully saved a message is displayed
                if (returnValue) {
                    Notifications.notify(t(`model.benefit_step4_6_message`), SUCCESS_NOTIFICATION);
                }
                else {
                    canSave = false;
                }
            }
        }

        if (canSave) {
            // Set the state and select the option
            setState({
                ...state,
                [data]: state[data].map((item) => {
                    if (item.name === event.dataItem.name) {
                        item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                    } else {
                        item[SELECTED_FIELD] = false;
                    }
                    return item;
                })
            });
            // saves the benefit id as state
            setSelectedBenefitId(event.dataItem.benefitId);
            // Fills the inputs with the selected benefit information
            fillInputs(event.dataItem.benefitId);
        }

    }

    // Gets the information of the selected benefit and set the state of each input
    const fillInputs = async (benefitId) => {
        try {
            const responseBenefitsData = await API.get(`/model/step6BenefitData?modelId=${props.modelData.modelid}&benefitId=${benefitId}`);
            // Message
            if (responseBenefitsData.data.data === null) {
                setPolicyGaps('');
                setImpIssues('');
                setPolicyRecom('');
                setAnnotations('');
            } else if (responseBenefitsData.data.code !== 100) {
                Notifications.notify(responseBenefitsData.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                setPolicyGaps(responseBenefitsData.data.data.policyGaps === null ? '' : responseBenefitsData.data.data.policyGaps);
                setImpIssues(responseBenefitsData.data.data.implemIssues === null ? '' : responseBenefitsData.data.data.implemIssues);
                setPolicyRecom(responseBenefitsData.data.data.policyRecom === null ? '' : responseBenefitsData.data.data.policyRecom);
                setAnnotations(responseBenefitsData.data.data.suppleAnnotations === null ? '' : responseBenefitsData.data.data.suppleAnnotations);
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    return (
        <div className="col-md-12">
            <div className="row">
                <h6>{t('model.step6_desc')}</h6>
            </div>
            <div className="row row_attrs container_steps">
                <div className="col-sm-12">
                    {/**Form step4*/}
                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label className="ilo_lbl_general">{t('model.step6_benefit')}</label>
                            <ListBox
                                style={{
                                    height: 200,
                                    width: "100%",
                                }}
                                data={state.benefitsList}
                                textField="name"
                                selectedField={SELECTED_FIELD}
                                onItemClick={(e) => modelBenfitsClick(e, "benefitsList")}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label className="ilo_lbl_general">{t('model.step6_gaps')}</label>
                            <textarea
                                className="form-control ilo-input ilo-modal-input-text-area"
                                disabled={!props.isEditMode}
                                rows="1"
                                value={policyGaps}
                                onChange={(e) => setPolicyGaps(e.target.value)}
                            ></textarea>
                        </div>
                        <div className="form-group col-md-6">
                            <label className="ilo_lbl_general">{t('model.step6_issues')}</label>
                            <textarea
                                className="form-control ilo-input ilo-modal-input-text-area"
                                disabled={!props.isEditMode}
                                rows="1"
                                value={impIssues}
                                onChange={(e) => setImpIssues(e.target.value)}
                            ></textarea>
                        </div>
                    </div>


                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label className="ilo_lbl_general">{t('model.step6_policy')}</label>
                            <textarea
                                className="form-control ilo-input ilo-modal-input-text-area"
                                disabled={!props.isEditMode}
                                rows="1"
                                value={policyRecom}
                                onChange={(e) => setPolicyRecom(e.target.value)}
                            ></textarea>
                        </div>

                        <div className="form-group col-md-6">
                            <label className="ilo_lbl_general">{t('model.step6_notes')}</label>
                            <textarea
                                className="form-control ilo-input ilo-modal-input-text-area"
                                disabled={!props.isEditMode}
                                rows="1"
                                value={annotations}
                                onChange={(e) => setAnnotations(e.target.value)}
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    <button className="btn_style" type="button" onClick={() => { onPreviousClick(); }} ><ImArrowLeft /></button>
                    <button className="btn_style" type="button" onClick={() => { onNextClick(); }} ><ImArrowRight /></button>
                </div>
            </div>
        </div>
    );
}

export default Step6